import {
    RaikoBaseDialogContentContainer, RaikoDatePicker,
    RaikoSectionContainer, RaikoSimpleInputOutlined, showServerErrorMessage,
    showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {useState} from "react";
import {CampaignsService} from "../CampaignsService";

export default function AddNewCampaign({handleCloseDialog, handleAddNewCampaign}) {

    const [title, setTitle] = useState("")
    const [slug, setSlug] = useState("")
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [buttonLoading, setButtonLoading] = useState(false)

    const service = new CampaignsService()


    function handleCreateCampaign() {
        setButtonLoading(true)
        service.createNewCampaign(title, slug, startDate, endDate)
            .then(response => {
                handleCloseDialog()
                handleAddNewCampaign(response)
                showSuccessMessage("پویش جدید با موفقیت ایجاد شد.")
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setButtonLoading(false)
        })


    }


    return (
        <RaikoBaseDialogContentContainer>
            <RaikoSectionContainer
                title={"افزودن پویش جدید"}
                hasActionButton
                actionButtonTitle={"افزودن"}
                actionButtonOnclickWithValidation={handleCreateCampaign}
                actionButtonLoadingState={buttonLoading}
                hasSecondaryButton
                secondaryButtonTitle={"بازگشت"}
                secondaryButtonOnClick={handleCloseDialog}
            >
                <RaikoSimpleInputOutlined
                    labelText={"عنوان پویش"}
                    value={title}
                    setValue={setTitle}
                    required
                />
                <RaikoSimpleInputOutlined
                    labelText={"slug"}
                    value={slug}
                    setValue={setSlug}
                    required
                />
                <RaikoDatePicker
                    label={"تاریخ شروع"}
                    date={startDate}
                    setDate={setStartDate}
                />
                <RaikoDatePicker
                    label={"تاریخ پایان"}
                    date={endDate}
                    setDate={setEndDate}
                />

            </RaikoSectionContainer>

        </RaikoBaseDialogContentContainer>
    )
}